import axios from 'axios'
import dmsconf from '../dmsconfig/devconfig.json'

function redireccionLogin(){
	let url_redireccion = ''
	if (process.env.NODE_ENV == 'production') {
		url_redireccion	= window.location.origin + '/SiDESK?continue=' + window.location.href
	} else {
		url_redireccion	= 'http://localhost:8083/SiDESK?continue=http://localhost:8082'
	}
	window.location.href = url_redireccion
}

export {redireccionLogin}

const url = (function () {


	if (localStorage.getItem('backUrl')) return localStorage.getItem('backUrl')

	let back = '/SiDMS.API/public/index.php/api/'
	let local = 'http://localhost/SiDMS.API/public/index.php/api/'

	return process.env.NODE_ENV == 'production' ? back : local

})()

const urlCron = (function () {

	if (localStorage.getItem('backUrlCron')) return localStorage.getItem('backUrlCron')

	let back = '/SiDMS.CMD/public/index.php/api/'
	let local = 'http://localhost/SiDMS.CMD/public/index.php/api/'

	return process.env.NODE_ENV == 'production' ? back : local

})()

const urlWorkflow = (function () {

	if (localStorage.getItem('backUrlCron')) return localStorage.getItem('backUrlCron')

	let back = '/SiWFW.API/public/'
	let local = 'http://localhost/SiWFW.API/public/'

	return process.env.NODE_ENV == 'production' ? back : local

})()

const CancelToken = axios.CancelToken

export function getUrl () { return url }

export function getCancelToken () { return CancelToken }

export function init () {

	let token =  localStorage.getItem('accessToken')
	if (process.env.NODE_ENV == 'development') token = dmsconf.accesstoken

	axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

	axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

	axios.defaults.headers.common['Content-Type'] = 'application/json'

	axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

	axios.interceptors.response.use(function (response) {

		return response

	}, function (error) {

		if (location.href.split('/').includes('login')) return Promise.reject(error)

		if (error && error.response && 401 === error.response.status) {

			localStorage.removeItem('accessToken')

			redireccionLogin()

		} else {

			return Promise.reject(error);

		}
	})


}

function queryParams(params) {
	return Object.keys(params).map(key => key + '=' + params[key]).join('&');
}

export function setToken (token) { axios.defaults.headers.common['Authorization'] = 'Bearer ' + token }

export function getElementoBusqueda (data) { return axios.post(`${url}elemento/busqueda`, data) }

export function postSelectorEntidad (entidad, data) { return axios.post(`${url}selector/guardarDato/${entidad}`, data) }

export function descargarElemento (id) { return axios.get(`${url}elemento/${id}`) }
export function descargarElementos (data) { return axios.post(`${url}elemento/descargamultiple`, data) }

export function login (data) { return axios.post(`${url}auth/login`, data) }

// VISOR
export function previsualizarElemento (id, pagina) { return axios.get(`${urlCron}elementos/${id}/previsualizar/${pagina}`) }

export function recargarPrevisualizarElemento (id, pagina) { return axios.get(`${urlCron}elementos/${id}/recargarprevisualizar/${pagina}`) }

// ESQUEMAS
export function getEsquemas () { return axios.get(`${url}user/esquemas`) }
export function nuevoEsquema (data) { return axios.post(`${url}esquemas`, data) }

// COLECCIONES
export function getColecciones () { return axios.get(`${url}lista/colecciones`) }

// CARPETAS
export function getCarpetas() { return axios.get(`${url}elemento/arbolCarpetas`) }

// INPUTS
export function getSelectInput(lista__id) { return axios.get(`${url}listas/valores/${lista__id}`) }

// PROPIEDADES
export function savePropiedades(id,data) { return axios.post(`${url}elemento/${id}/metadatos`, data) }

// NOTAS
export function editarNotaElemento(id, data){ return axios.post(`${url}elemento/${id}/notas`, data)}

// ETIQUETAS
export function editarEtiquetaElemento(id, data){ return axios.post(`${url}elemento/${id}/etiquetas`, data)}

// ELEMENTOS
export function borrarElemento(data) { return axios.post(`${url}elemento/reubicar/borrar`, data) }

// OCR
export function ocrElemento (plantilla, id) { return axios.get(`${urlCron}ficheros/ocr/plantilla/${plantilla}/fichero/${id}`) }

// LISTAS ESTRUCTURA
export function getListasEstructura (data) { return axios.post(`${url}listas/estructura`, data) }

// LISTA ESPECIAL USUARIOS
export function getSelectUsers () { return axios.get(`${url}userindex`) }

// LISTA EQUIVALENCIAS
export function getListaEquivalencias () { return axios.get(`${url}lista/equivalencias`)}

// EXPEDIENTES
export function getExpedientes (data) { return axios.get(`${url}expediente?${queryParams(data)}`) }
export function getExpedientesTipo (data) { return axios.get(`${url}expedientes`) }

// URL SUBIDA DE ARCHIVOS
export function getUploadURL () { return `${url}ficheros/1/0`}

// CARGA DE INFO DEL USUARIO
export function cargarUsuario () { return axios.get(`${url}user/carga`) }

// OBTENER BINARIO
export function obtenerBinario (data) { return axios.post(`${url}ficheros/compartirbinario`, data) }

// EJECUTAR ELECCION
export function ejecutarEleccion (data) { return axios.get(`${urlWorkflow}ejecutareleccion?${queryParams(data)}`) }

// BUSQUEDA PERSONALIZADA
export function getBusquedaPersonalizada (data) { return axios.post(`${url}busquedapersonalizada`, data) }